import { EditorSelection } from "@uiw/react-codemirror";
import * as YAML from "yaml";

export const isJson = (string) => {
  return string && string[0] === "{";
};

export const extractLineColumn = (error) => {
  try {
    const line = error.match(/line (\d+)/)[1];
    const column = error.match(/column (\d+)/)[1] - 1;
    return line + ":" + column;
  } catch (e) {
    console.log(e.message);
    return "0:0"; //This is to prevent error in jumpToPosition function
  }
};

export const jumpToPosition = (lineNumber, column, editorRef) => {
  try {
    if (editorRef.current) {
      const view = editorRef.current.view;
      if (view) {
        const line = view.state.doc.line(lineNumber);
        const position = line.from + column;
        view.dispatch({
          selection: EditorSelection.cursor(position),
          scrollIntoView: true,
        });
        view.focus();
      }
    }
  } catch (e) {
    console.log(e);
    throw new Error("Unable to jump to the line");
  }
};

export const convertContentType = (content) => {
  return isJson(content)
    ? YAML.stringify(JSON.parse(content))
    : JSON.stringify(YAML.parse(content), null, 2);
};
